import type { LucideIcon } from "lucide-react";
import { CalendarRange, Table as TableIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui";
import type { RelationView } from "~/features/relations/types";
import { cn } from "~/lib/utils";

// Static t() references so i18next-extract (removeUnusedKeys) keeps the dynamically-used labelKeys.
// t("ui.table") t("ui.timeline")
const VIEWS: Array<{ value: RelationView; icon: LucideIcon; labelKey: string }> = [
  { value: "table", icon: TableIcon, labelKey: "ui.table" },
  { value: "timeline", icon: CalendarRange, labelKey: "ui.timeline" },
];

interface RelationsViewSwitcherProps {
  value: RelationView;
  onChange: (next: RelationView) => void;
}

export function RelationsViewSwitcher({ value, onChange }: RelationsViewSwitcherProps) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex items-center gap-1 rounded-[var(--radius-md)] border border-border-default bg-bg-subtle p-0.5">
      {VIEWS.map(({ value: v, icon: Icon, labelKey }) => {
        const active = v === value;
        return (
          <Button
            key={v}
            type="button"
            variant={active ? "default" : "ghost"}
            size="sm"
            onClick={() => onChange(v)}
            aria-pressed={active}
            className={cn(!active && "text-fg-2")}
          >
            <Icon />
            <span>{t(labelKey)}</span>
          </Button>
        );
      })}
    </div>
  );
}
